import { useDispatch, useSelector } from 'react-redux';
import { Col, Row } from 'antd';

import { getErrorMessageFromAPI } from '@/utilz';

import {
  setOverChargeClaimEditActiveKey,
  setOverChargeClaimsEditDrawer,
} from '../../../../../../../redux/Claims/OverCharge/OverChargeActions';
import { setPageBlocker } from '../../../../../../../redux/common/CommonActions';
import PrimaryLabel from '../../../../../../components/Labels/PrimaryLabel';
import Drawer from '../../../../../../components/Modals/Drawer';
import ContentSpinner from '../../../../../../components/Spinners/ContentSpinner';
import { useGetOCClaimDetails } from '../../../hooks';
import OverChargeEditTabs from '../Tabs/OverChargeEditTabs';
import OverChargeDrawerHeader from './OverChargeDrawerHeader';

const OverChargeEditDrawer = ({ claimKey, onClaimKeyReset }) => {
  const dispatch = useDispatch();
  const { editDrawer, editTabKey } = useSelector((state) => state.overChargeClaims);
  const { data: claimDetails, error, isError, isFetching } = useGetOCClaimDetails(claimKey);

  const handleOpenChange = (isOpen) => {
    if (!isOpen) {
      dispatch(setPageBlocker(false));
      onClaimKeyReset?.();
    } else {
      dispatch(setOverChargeClaimEditActiveKey('1'));
    }
  };

  const handleTabChange = (key) => dispatch(setOverChargeClaimEditActiveKey(key));

  return (
    <Drawer
      open={editDrawer}
      onClose={() => dispatch(setOverChargeClaimsEditDrawer(false))}
      headerContents={
        <OverChargeDrawerHeader
          claimDetails={claimDetails}
          claimNo={claimDetails?.customerClaimNo}
          currency={claimDetails?.currencyCode}
        />
      }
      width="85%"
      afterOpenChange={handleOpenChange}
      destroyOnHidden
    >
      {isFetching ? (
        <div className="p-30 vh-90">
          <ContentSpinner size="large" />
        </div>
      ) : claimDetails?.fbOcKey ? (
        <OverChargeEditTabs
          handleTabChange={handleTabChange}
          activeKey={editTabKey}
          claimDetails={claimDetails}
          key={claimDetails.fbOcKey}
        />
      ) : isError ? (
        <Row justify="center" align="middle" className="h-100">
          <Col>
            <PrimaryLabel className="text-danger f-25">
              {getErrorMessageFromAPI(error, 'Failed to load claim details.')}
            </PrimaryLabel>
          </Col>
        </Row>
      ) : null}
    </Drawer>
  );
};

export default OverChargeEditDrawer;
